import { ColorSets } from 'constants/calendar';
import { get } from 'lodash';
import { momentTimezone } from 'utils/time';
import { PIXEL_PER_MINUTE } from './styles';
import { IColorSetItem } from './types';
import moment from 'moment';

export const getNearestTimeSlotId = (): string => {
  const now = moment();
  
  const minutes = now.minutes();
  const roundedMinutes = Math.floor(minutes / 15) * 15;
  
  const hour = now.format('hh');
  const minuteStr = roundedMinutes.toString().padStart(2, '0');
  const period = now.format('A');
  
  return `to_${hour}-${minuteStr}-${period}_time`;
};

const calcTo = (currentTime: string) => {
  const open = momentTimezone(currentTime).set({ hour: 8, minute: 0, second: 0 });
  const close = momentTimezone(currentTime).set({ hour: 23, minute: 0, second: 0 });
  const now = momentTimezone(currentTime);
  const currentSpaceMinutes = now.diff(open, 'minutes');

  let space = 0;
  
  const RowHeight = (PIXEL_PER_MINUTE.value * 15) + 2;

  if (now.isBetween(open, close))
    space = (RowHeight / 15) * currentSpaceMinutes;
  return space;
};

export default calcTo;

// @ts-ignore
export const getColorSet = (type?: number | null) => (get(ColorSets, [type], null) as IColorSetItem) || ColorSets.default;
